module.exports = __webpack_public_path__ + "img/vegetable-rapini-350x184.77317b51.jpg";